import type { BriefEntry } from './useSalePanels'
import { BriefList, BriefNote, BriefRules, BriefTerm, BriefValue } from './styled-components'

interface ProductBriefProps {
  brief: BriefEntry[]
  rules: string[]
  hasRules: boolean
  note: string
}

const ProductBrief = ({ brief, rules, hasRules, note }: ProductBriefProps) => (
  <>
    <BriefList>
      {brief.map((entry, index) => (
        <div key={entry.term}>
          <BriefTerm $first={index === 0}>{entry.term}</BriefTerm>
          <BriefValue>{entry.value}</BriefValue>
        </div>
      ))}
    </BriefList>
    {hasRules && (
      <BriefRules>
        {rules.map(rule => (
          <li key={rule}>{rule}</li>
        ))}
      </BriefRules>
    )}
    {note && <BriefNote>{note}</BriefNote>}
  </>
)

export default ProductBrief
